<template>
  <div class="w-full rounded-md border border-light-gray bg-white p-6">
    <!-- <div class="flex gap-6 w-full items-center">
      <h3 class="text-2xl text-dark-gray">Safety</h3>
      <div class="flex items-center">
        <custom-badge
          v-if="emptyElement(safety?.basic_percentile_rankings?.unsafe_driving) && emptyElement(safety?.basic_percentile_rankings?.hos_compliance) && emptyElement(safety?.basic_percentile_rankings?.vehicle_maintenance) && emptyElement(safety?.basic_percentile_rankings?.substance_alcohol) && emptyElement(safety?.basic_percentile_rankings?.driver_fitness)"
          bgColorClass="bg-light-gray"
          colorClass="text-body-color"
          size="md"
          text="No Safety Records Found"
          class="mr-2"
        ></custom-badge>
      </div>
      <div class="flex items-center">
        <custom-badge
          v-if="!emptyElement(safety.safety_rating)"
          :bgColorClass="safetyRatingBgColor"
          colorClass="text-white"
          size="lg"
          :text="safety.safety_rating" 
        ></custom-badge>
      </div>
      
      <div class="text-dark-gray" v-show="safety.safety_rating_effective_date">
        Effective Safety Rating Date {{ displayDate(safety.safety_rating_effective_date) }}
      </div>
    </div> -->
    <div
      v-show="
        !emptyElement(safety?.basic_percentile_rankings?.unsafe_driving) ||
        !emptyElement(safety?.basic_percentile_rankings?.hos_compliance) ||
        !emptyElement(safety?.basic_percentile_rankings?.vehicle_maintenance) ||
        !emptyElement(safety?.basic_percentile_rankings?.substance_alcohol) ||
        !emptyElement(safety?.basic_percentile_rankings?.driver_fitness)
      "
    >
      <div class="mb-4 mt-0 flex gap-6">
        <button
          v-if="
            insight?.associated_sms_basics?.[0]
              ?.is_unsafe_driving_acute_critical == true
          "
          class="group h-16 rounded-md"
          :class="{
            'bg-orange-200': chartTitle == 'Unsafe Driving',
            'bg-orange-150': chartTitle !== 'Unsafe Driving',
          }"
        >
          <div
            class="flex h-full w-full items-center justify-center gap-3 rounded-md border border-orange-500 px-2 py-1 ring-inset ring-orange-500 hover:bg-orange-200"
            :class="{
              'bg-orange-200 ring-2': chartTitle == 'Unsafe Driving',
              'bg-orange-150': chartTitle !== 'Unsafe Driving',
            }"
            @click="onSelectChartTile('Unsafe Driving')"
          >
            >
            <div class="h-12 w-12">
              <svg
                class="h-full w-full text-orange-500 group-hover:text-orange-500"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.69726 25.6151C9.5211 24.5959 10.1512 23.6104 11.1504 23.3427L28.8724 18.5941C29.8715 18.3264 30.91 18.8647 31.2671 19.8355L33.6935 26.4323C34.0995 27.5361 33.4701 28.7502 32.3341 29.0546L13.3827 34.1326C12.2467 34.437 11.0946 33.7002 10.8943 32.5413L9.69726 25.6151Z"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M10.4307 14.9763C10.4348 14.5271 10.7379 14.1358 11.1718 14.0195L24.1923 10.5307C24.6262 10.4144 25.0844 10.6017 25.3126 10.9887L29.6707 18.3802L10.3522 23.5566L10.4307 14.9763Z"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <rect
                  x="4.02039"
                  y="7.6543"
                  width="24"
                  height="17"
                  rx="1"
                  transform="rotate(-15 4.02039 7.6543)"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M12.822 17.4915C12.8038 17.0247 13.1112 16.6074 13.5624 16.4865L23.3546 13.8627C23.8058 13.7418 24.2807 13.9494 24.4983 14.3628L26.5141 18.1925L12.9911 21.816L12.822 17.4915Z"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M14.165 33.9238L19.9606 32.3709L20.7371 35.2687C20.88 35.8022 20.5634 36.3505 20.0299 36.4934L16.1662 37.5287C15.6328 37.6717 15.0844 37.3551 14.9415 36.8216L14.165 33.9238Z"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M26.7222 30.5586L32.5177 29.0057L33.2942 31.9035C33.4371 32.4369 33.1205 32.9853 32.5871 33.1282L28.7234 34.1635C28.1899 34.3064 27.6416 33.9898 27.4986 33.4564L26.7222 30.5586Z"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <rect
                  x="25.6176"
                  y="22.5723"
                  width="3"
                  height="4"
                  rx="1"
                  transform="rotate(-15 25.6176 22.5723)"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <rect
                  x="13.0604"
                  y="25.9375"
                  width="3"
                  height="4"
                  rx="1"
                  transform="rotate(-15 13.0604 25.9375)"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </div>
            <div
              class="w-28 text-left text-xs font-medium text-orange-500 group-hover:text-orange-500"
              :class="{
                'font-bold': chartTitle == 'Unsafe Driving',
              }"
            >
              Unsafe Driving
            </div>
          </div>
        </button>
        <button
          v-if="
            insight?.associated_sms_basics?.[0]
              ?.is_hos_compliance_acute_critical == true
          "
          class="group h-16 rounded-md"
          :class="{
            'bg-orange-200': chartTitle == 'Hours-of-Service Compliance',
            'bg-orange-150': chartTitle !== 'Hours-of-Service Compliance',
          }"
        >
          <div
            class="flex h-full w-full items-center justify-center gap-3 rounded-md border border-orange-500 px-2 py-1 ring-inset ring-orange-500 hover:bg-orange-200"
            :class="{
              'bg-orange-200 ring-2':
                chartTitle == 'Hours-of-Service Compliance',
              'bg-orange-150': chartTitle !== 'Hours-of-Service Compliance',
            }"
            @click="onSelectChartTile('Hours-of-Service Compliance')"
          >
            <div class="h-12 w-12">
              <svg
                class="h-full w-full text-orange-500 group-hover:text-orange-500"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="17.3486"
                  cy="17.0039"
                  r="16"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M17.3486 7.00391V17.0039"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M23.3486 17.0039L17.3486 17.0039"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <circle
                  cx="17.3486"
                  cy="30.0039"
                  r="1"
                  fill="currentColor"
                />
                <circle
                  cx="17.3486"
                  cy="4.00391"
                  r="1"
                  fill="currentColor"
                />
                <circle
                  cx="4.34863"
                  cy="17.0039"
                  r="1"
                  transform="rotate(90 4.34863 17.0039)"
                  fill="currentColor"
                />
                <circle
                  cx="30.3486"
                  cy="17.0039"
                  r="1"
                  transform="rotate(90 30.3486 17.0039)"
                  fill="currentColor"
                />
                <circle
                  cx="8.15622"
                  cy="7.81055"
                  r="1"
                  transform="rotate(135 8.15622 7.81055)"
                  fill="currentColor"
                />
                <circle
                  cx="26.541"
                  cy="26.1953"
                  r="1"
                  transform="rotate(135 26.541 26.1953)"
                  fill="currentColor"
                />
                <circle
                  cx="26.541"
                  cy="7.81235"
                  r="1"
                  transform="rotate(-135 26.541 7.81235)"
                  fill="currentColor"
                />
                <circle
                  cx="8.15625"
                  cy="26.1971"
                  r="1"
                  transform="rotate(-135 8.15625 26.1971)"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div
              class="w-28 text-left text-xs font-medium text-orange-500 group-hover:text-orange-500"
              :class="{
                'font-bold': chartTitle == 'Hours-of-Service Compliance',
              }"
            >
              Hours-of-Service Compliance
            </div>
          </div>
        </button>
        <button
          v-if="
            insight?.associated_sms_basics?.[0]
              ?.is_vehicle_maintenance_acute_critical == true
          "
          class="group h-16 rounded-md"
          :class="{
            'shadow-orange bg-orange-200': chartTitle == 'Vehicle Maintenance',
          }"
        >
          <div
            class="flex h-full w-full items-center justify-center gap-3 rounded-md border px-2 py-1 ring-inset ring-orange-500 hover:border-orange-500 hover:bg-orange-200"
            :class="{
              'border-orange-500 bg-orange-200 ring-2':
                chartTitle == 'Vehicle Maintenance',
              'border-gray-over-dark': chartTitle !== 'Vehicle Maintenance',
            }"
            @click="onSelectChartTile('Vehicle Maintenance')"
          >
            <div class="h-12 w-12">
              <svg
                class="h-full w-full group-hover:text-orange-500"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  'text-orange-500': chartTitle === 'Vehicle Maintenance',
                  'text-gray-over-dark': chartTitle !== 'Vehicle Maintenance',
                }"
              >
                <g clip-path="url(#clip0_1243_21682)">
                  <path
                    d="M6.08011 4.72311L6.94614 4.22311L6.07934 2.72179L5.2137 4.22378L6.08011 4.72311ZM12.228 14.7195L13.0941 14.2195L12.7868 13.6872L12.1731 13.721L12.228 14.7195ZM17.9037 24.55L18.8538 24.862L18.9933 24.4372L18.7697 24.05L17.9037 24.55ZM22.9766 21.6224L22.1106 22.1224L22.334 22.5095L22.7714 22.6012L22.9766 21.6224ZM17.3394 11.8585L16.517 11.2895L16.1568 11.8102L16.4733 12.3585L17.3394 11.8585ZM11.856 1.38894L11.857 0.388941L10.1231 0.387359L10.99 1.88894L11.856 1.38894ZM14.0674 5.97484L14.924 6.49081L14.924 6.49081L14.0674 5.97484ZM12.533 8.52218L11.6764 8.00621L11.6764 8.00621L12.533 8.52218ZM11.9194 8.87643L11.9009 7.8766L11.9009 7.8766L11.9194 8.87643ZM8.9462 8.93156L8.96474 9.93139L8.96474 9.93139L8.9462 8.93156ZM22.1743 23.7522L22.6743 22.8862L22.1743 22.5975L21.6743 22.8862L22.1743 23.7522ZM20.2722 24.8504L19.7722 23.9844L19.2722 24.2731L19.2722 24.8504L20.2722 24.8504ZM24.0764 24.8504L25.0764 24.8504L25.0764 24.2731L24.5764 23.9844L24.0764 24.8504ZM24.0764 27.0468L24.5764 27.9128L25.0765 27.6242L25.0764 27.0468L24.0764 27.0468ZM22.1743 28.145L21.6743 29.011L22.1743 29.2997L22.6743 29.011L22.1743 28.145ZM20.2722 27.0468L19.2722 27.0468L19.2722 27.6242L19.7722 27.9128L20.2722 27.0468ZM6.94653 10.8938C5.89788 9.07754 5.96743 6.92129 6.94652 5.22245L5.2137 4.22378C3.89274 6.51579 3.79441 9.43421 5.21448 11.8938L6.94653 10.8938ZM12.1731 13.721C10.104 13.8349 8.05132 12.8074 6.94653 10.8938L5.21448 11.8938C6.71072 14.4854 9.49037 15.8717 12.283 15.718L12.1731 13.721ZM18.7697 24.05L13.0941 14.2195L11.362 15.2195L17.0377 25.05L18.7697 24.05ZM16.9536 24.238C16.4922 25.643 16.6076 27.2349 17.4064 28.6185L19.1385 27.6185C18.636 26.7482 18.5624 25.7493 18.8538 24.862L16.9536 24.238ZM17.4064 28.6185C18.8956 31.1978 22.1938 32.0816 24.7731 30.5924L23.7731 28.8603C22.1504 29.7972 20.0754 29.2412 19.1385 27.6185L17.4064 28.6185ZM24.7731 30.5924C27.3524 29.1032 28.2362 25.805 26.747 23.2257L25.015 24.2257C25.9518 25.8485 25.3959 27.9234 23.7731 28.8603L24.7731 30.5924ZM26.747 23.2257C25.9486 21.8428 24.6285 20.947 23.1818 20.6437L22.7714 22.6012C23.685 22.7927 24.5127 23.3558 25.015 24.2257L26.747 23.2257ZM16.4733 12.3585L22.1106 22.1224L23.8426 21.1224L18.2054 11.3585L16.4733 12.3585ZM16.7659 5.22465C17.8974 7.18457 17.7267 9.54103 16.517 11.2895L18.1617 12.4275C19.7948 10.0671 20.0304 6.87907 18.4979 4.22465L16.7659 5.22465ZM11.8551 2.38894C13.8156 2.39073 15.7174 3.4086 16.7659 5.22465L18.4979 4.22465C17.078 1.76536 14.502 0.391354 11.857 0.388941L11.8551 2.38894ZM14.9403 4.73102L12.7221 0.888941L10.99 1.88894L13.2083 5.73102L14.9403 4.73102ZM14.924 6.49081C15.2492 5.95088 15.2555 5.27689 14.9403 4.73102L13.2083 5.73102C13.1595 5.6466 13.1605 5.54237 13.2108 5.45887L14.924 6.49081ZM13.3896 9.03815L14.924 6.49081L13.2108 5.45887L11.6764 8.00621L13.3896 9.03815ZM11.938 9.87626C12.5338 9.86521 13.0821 9.54864 13.3896 9.03815L11.6764 8.00621C11.724 7.92727 11.8088 7.87831 11.9009 7.8766L11.938 9.87626ZM8.96474 9.93139L11.938 9.87626L11.9009 7.8766L8.92766 7.93173L8.96474 9.93139ZM7.43256 9.06562C7.74772 9.61149 8.33453 9.94307 8.96474 9.93139L8.92766 7.93173C9.02512 7.92992 9.11587 7.9812 9.16461 8.06562L7.43256 9.06562ZM5.21408 5.22311L7.43256 9.06562L9.16461 8.06562L6.94614 4.22311L5.21408 5.22311ZM21.6743 22.8862L19.7722 23.9844L20.7722 25.7164L22.6743 24.6183L21.6743 22.8862ZM24.5764 23.9844L22.6743 22.8862L21.6743 24.6183L23.5764 25.7164L24.5764 23.9844ZM25.0764 27.0468L25.0764 24.8504L23.0764 24.8504L23.0764 27.0468L25.0764 27.0468ZM22.6743 29.011L24.5764 27.9128L23.5764 26.1808L21.6743 27.279L22.6743 29.011ZM19.7722 27.9128L21.6743 29.011L22.6743 27.279L20.7722 26.1808L19.7722 27.9128ZM19.2722 24.8504L19.2722 27.0468L21.2722 27.0468L21.2722 24.8504L19.2722 24.8504Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1243_21682">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.191895 0.390625)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              class="w-28 text-left text-xs font-medium text-body-color group-hover:text-orange-500"
              :class="{
                'font-bold text-orange-500':
                  chartTitle == 'Vehicle Maintenance',
              }"
            >
              Vehicle Maintenance
            </div>
          </div>
        </button>
        <button
          v-if="
            insight?.associated_sms_basics?.[0]
              ?.is_substance_alcohol_acute_critical == true
          "
          class="group h-16 rounded-md"
          :class="{
            'shadow-orange bg-orange-200':
              chartTitle == 'Controlled Substances & Alcohol',
          }"
        >
          <div
            class="flex h-full w-full items-center justify-center gap-3 rounded-md border px-2 py-1 ring-inset ring-orange-500 hover:border-orange-500 hover:bg-orange-200"
            :class="{
              'border-orange-500 bg-orange-200 ring-2':
                chartTitle == 'Controlled Substances & Alcohol',
              'border-gray-over-dark ring-inset ring-gray-500':
                chartTitle !== 'Controlled Substances & Alcohol',
            }"
            @click="onSelectChartTile('Controlled Substances & Alcohol')"
          >
            <div class="h-12 w-12">
              <svg
                class="h-full w-full group-hover:text-orange-500"
                :class="{
                  'text-orange-500':
                    chartTitle === 'Controlled Substances & Alcohol',
                  'text-gray-over-dark':
                    chartTitle !== 'Controlled Substances & Alcohol',
                }"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1223_21775)">
                  <path
                    d="M6.48653 8.19257L5.56738 7.79865L6.48653 8.19257ZM14.4865 14.8152L13.5674 15.2092L14.4865 14.8152ZM11.6482 8.19257L12.5674 7.79865L11.6482 8.19257ZM10.5674 0.00390625H7.56738V2.00391H10.5674V0.00390625ZM12.5674 7.79865V2.00391H10.5674V7.79865H12.5674ZM10.7291 8.58649L13.5674 15.2092L15.4057 14.4213L12.5674 7.79865L10.7291 8.58649ZM15.5674 30.0039V15.2092H13.5674V30.0039H15.5674ZM4.56738 32.0039H13.5674V30.0039H4.56738V32.0039ZM2.56738 15.2092V30.0039H4.56738V15.2092H2.56738ZM4.56738 15.2092L7.40567 8.58649L5.56738 7.79865L2.72909 14.4213L4.56738 15.2092ZM5.56738 2.00391V7.79865H7.56738V2.00391H5.56738ZM7.40567 8.58649C7.51237 8.33753 7.56738 8.0695 7.56738 7.79865H5.56738V7.79865L7.40567 8.58649ZM4.56738 15.2092L2.72909 14.4213C2.6224 14.6703 2.56738 14.9383 2.56738 15.2092H4.56738ZM4.56738 30.0039H2.56738C2.56738 31.1085 3.46281 32.0039 4.56738 32.0039V30.0039ZM13.5674 30.0039V32.0039C14.672 32.0039 15.5674 31.1085 15.5674 30.0039H13.5674ZM13.5674 15.2092H15.5674C15.5674 14.9383 15.5124 14.6703 15.4057 14.4213L13.5674 15.2092ZM10.5674 7.79865C10.5674 8.0695 10.6224 8.33753 10.7291 8.58649L12.5674 7.79865H10.5674ZM7.56738 0.00390625C6.46281 0.00390625 5.56738 0.899337 5.56738 2.00391H7.56738V0.00390625ZM10.5674 2.00391V2.00391H12.5674C12.5674 0.899337 11.672 0.00390625 10.5674 0.00390625V2.00391Z"
                    fill="currentColor"
                  />
                  <path
                    d="M21.4865 8.19257L20.5674 7.79865L21.4865 8.19257ZM29.4865 14.8152L28.5674 15.2092L29.4865 14.8152ZM26.6482 8.19257L27.5674 7.79865L26.6482 8.19257ZM25.5674 0.00390625H22.5674V2.00391H25.5674V0.00390625ZM27.5674 7.79865V2.00391H25.5674V7.79865H27.5674ZM25.7291 8.58649L28.5674 15.2092L30.4057 14.4213L27.5674 7.79865L25.7291 8.58649ZM30.5674 30.0039V15.2092H28.5674V30.0039H30.5674ZM19.5674 32.0039H28.5674V30.0039H19.5674V32.0039ZM17.5674 15.2092V30.0039H19.5674V15.2092H17.5674ZM19.5674 15.2092L22.4057 8.58649L20.5674 7.79865L17.7291 14.4213L19.5674 15.2092ZM20.5674 2.00391V7.79865H22.5674V2.00391H20.5674ZM22.4057 8.58649C22.5124 8.33753 22.5674 8.0695 22.5674 7.79865H20.5674V7.79865L22.4057 8.58649ZM19.5674 15.2092L17.7291 14.4213C17.6224 14.6703 17.5674 14.9383 17.5674 15.2092H19.5674ZM19.5674 30.0039H17.5674C17.5674 31.1085 18.4628 32.0039 19.5674 32.0039V30.0039ZM28.5674 30.0039V32.0039C29.672 32.0039 30.5674 31.1085 30.5674 30.0039H28.5674ZM28.5674 15.2092H30.5674C30.5674 14.9383 30.5124 14.6703 30.4057 14.4213L28.5674 15.2092ZM25.5674 7.79865C25.5674 8.0695 25.6224 8.33753 25.7291 8.58649L27.5674 7.79865H25.5674ZM22.5674 0.00390625C21.4628 0.00390625 20.5674 0.899337 20.5674 2.00391H22.5674V0.00390625ZM25.5674 2.00391V2.00391H27.5674C27.5674 0.899337 26.672 0.00390625 25.5674 0.00390625V2.00391Z"
                    fill="currentColor"
                  />
                  <path
                    d="M3.56738 15.0039H14.5674"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M18.5674 15.0039H29.5674"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <rect
                    x="2.56738"
                    y="18.0039"
                    width="28"
                    height="13"
                    rx="1"
                    :fill="
                      chartTitle === 'Controlled Substances & Alcohol'
                        ? '#ffe4cb'
                        : '#ffffff'
                    "
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <rect
                    x="6.56738"
                    y="21.0039"
                    width="20"
                    height="7"
                    rx="1"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1223_21775">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.567383 0.00390625)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              class="w-28 text-left text-xs font-medium text-body-color group-hover:text-orange-500"
              :class="{
                'font-bold text-orange-500':
                  chartTitle == 'Controlled Substances & Alcohol',
              }"
            >
              Controlled Substances & Alcohol
            </div>
          </div>
        </button>
        <button
          v-if="
            insight?.associated_sms_basics?.[0]
              ?.is_driver_fitness_acute_critical == true
          "
          class="group h-16 rounded-md"
          :class="{
            'bg-orange-200': chartTitle == 'Driver Fitness',
            'bg-orange-150': chartTitle !== 'Driver Fitness',
          }"
        >
          <div
            class="flex h-full w-full items-center justify-center gap-3 rounded-md border border-orange-500 px-2 py-1 ring-inset ring-orange-500 hover:bg-orange-200"
            :class="{
              'bg-orange-200 ring-2': chartTitle == 'Driver Fitness',
              'bg-orange-150': chartTitle !== 'Driver Fitness',
            }"
            @click="onSelectChartTile('Driver Fitness')"
          >
            <div class="h-12 w-12">
              <svg
                class="h-full w-full text-orange-500 group-hover:text-orange-500"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="16.3486"
                  cy="9.00391"
                  r="6"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <circle
                  cx="16.3486"
                  cy="6.75391"
                  r="1.5"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M12.1861 13.5039V13.5039C11.6573 12.045 12.7379 10.5039 14.2897 10.5039H18.4076C19.9594 10.5039 21.04 12.045 20.5111 13.5039V13.5039"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <rect
                  x="6.34863"
                  y="19.0039"
                  width="20"
                  height="2"
                  rx="1"
                  fill="currentColor"
                />
                <rect
                  x="6.34863"
                  y="23.0039"
                  width="20"
                  height="2"
                  rx="1"
                  fill="currentColor"
                />
                <rect
                  x="6.34863"
                  y="27.0039"
                  width="20"
                  height="2"
                  rx="1"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div
              class="w-28 text-left text-xs font-medium text-orange-500 group-hover:text-orange-500"
              :class="{
                'font-bold': chartTitle == 'Driver Fitness',
              }"
            >
              Driver Fitness
            </div>
          </div>
        </button>
      </div>
      <div class="-mt-0.5 flex w-full items-center gap-6">
        <div class="flex-between flex w-full items-center">
          <div class="flex w-full items-center gap-6">
            <h4 class="inline-block whitespace-nowrap text-lg text-dark-gray">
              {{ chartTitle }}
            </h4>
            <!-- <div class="flex items-center gap-2 text-dark-gray">
              <div>On-Road Performance</div>
              <div class="text-orange-500">{{ safety.onRoadPerformance }}</div>
            </div> -->
            <div class="flex items-center">
              <custom-badge
                bg-color-class="bg-orange-500"
                color-class="text-white"
                size="md"
                text="Acute or Critical SMS Violation"
                icon="exclamation"
              ></custom-badge>
            </div>
          </div>
          <div class="block w-full text-right">
            <div class="flex flex-col items-end">
              <div class="text-xl font-semibold text-orange-500">
                {{ chartPercentile }}
              </div>
              <div
                class="mt-0.5 text-xs text-orange-500"
                style="max-width: 200px"
              >
                {{ chartPercentileDescription }} among carriers with a similar
                fleet size
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="safetyChartWrapInsight"
        ref="safetyChartWrapInsight"
        class="my-2.5 h-96 w-full"
      >
        <line-chart
          v-if="
            !emptyElement(safety?.basic_percentile_rankings?.unsafe_driving) ||
            !emptyElement(safety?.basic_percentile_rankings?.hos_compliance) ||
            !emptyElement(
              safety?.basic_percentile_rankings?.vehicle_maintenance
            ) ||
            !emptyElement(
              safety?.basic_percentile_rankings?.substance_alcohol
            ) ||
            !emptyElement(safety?.basic_percentile_rankings?.driver_fitness)
          "
          :width="chartWidth"
          :height="chartHeight"
          :plot-data="chartData"
          color="orange"
          :top10-pct="parseFloat(top10Pct)"
          :bottom10-pct="parseFloat(bottom10Pct)"
        ></line-chart>
        <div class="mt-4 block text-center text-2xs text-gray-over-dark">
          *Note: 0 indicates the best performance
        </div>
      </div>
    </div>
    <!-- <div v-if="!emptyElement(violations.unsafe_driving.violations) || !emptyElement(violations.hos_compliance.violations) || !emptyElement(violations.vehicle_maintenance.violations) || !emptyElement(violations.substance_alcohol.violations) || !emptyElement(violations.driver_fitness.violations)">
      <div class="mt-20 mb-6">
        <div class="flex flex-between-items-center">
          <div class="flex gap-6 w-full items-center">
            <h4 class="text-lg text-dark-gray">Violations</h4>
            <div class="flex items-center">
              <custom-badge
                :bgColorClass="selectedViolationsSection.total === 0 ? 'bg-green-500': 'bg-orange-500'"
                colorClass="text-white"
                size="lg"
                iconSize="xl"
                :icon="selectedViolationsSection.total === 0 ? 'checkmark': 'exclamation'"
                :text=" chartTitle + ': ' + selectedViolationsSection.total"
              ></custom-badge>
            </div>
          </div>
          <div class="block w-full text-right text-body-color">Total Violations: {{ violations.total }}</div>
        </div>
        
        
        <div class="table-wrap rounded-md border border-light-gray mt-3">
          <table class="table-auto striped w-full">
            <thead class="border-b border-light-gray">
              <tr
                class="
                  text-left
                  font-medium
                  text-xs
                  h-14
                  text-dark-gray
                  cursor-pointer
                  select-none
                "
              >
                <th class="hover:bg-lighter-gray pl-4">
                  Violation Date
                </th>
                <th class="hover:bg-lighter-gray text-left px-2">
                  Violation Code
                </th>
                <th class="hover:bg-lighter-gray text-left px-2">
                  Type
                </th>
                <th class="hover:bg-lighter-gray text-left px-2">
                  Description
                </th>

                <th class="hover:bg-lighter-gray text-left px-2">
                  OOS Violation?
                </th>
                <th class="hover:bg-lighter-gray text-left px-2">
                  Time Weight
                </th>
                <th class="hover:bg-lighter-gray text-left px-2">
                  Total Severity Weight
                </th>
                <th class="hover:bg-lighter-gray text-left px-2">
                  Violation Value
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="violation in selectedViolationRecords"
                :key="violation.id"
                class="
                  text-xs text-left text-body-color
                  h-14
                  hover:bg-lighter-gray
                  cursor-pointer
                "
              >
                <td class="text-left px-2">{{ displayDate(violation.inspection_date) }}</td>
                <td class="text-left px-2">{{ violation.violation_code }}</td>
                <td class="text-left px-2">{{ violation.group_description }}</td>
                <td class="text-left px-2">{{ violation.section_description }}</td>

                <td class="text-left px-2">
                  <div v-if="violation.is_oos_violation" class="h-4 text-dark-gray">
                    <svg class="w-full h-full" viewBox="0 0 13 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30466 12.2119C9.35139 12.2119 11.8212 9.74201 11.8212 6.69529C11.8212 5.8144 11.6148 4.98173 11.2476 4.24303L6.49714 8.99348L5.93988 9.55074L5.38262 8.99348L2.95534 6.56621L4.06986 5.45169L5.93988 7.32171L10.3341 2.92748C9.32739 1.8513 7.89458 1.17871 6.30466 1.17871C3.25794 1.17871 0.788086 3.64857 0.788086 6.69529C0.788086 9.74201 3.25794 12.2119 6.30466 12.2119Z" />
                    </svg>
                  </div>
                  <div v-if="!violation.is_oos_violation" class="h-4 text-dark-gray">
                    <svg class="w-full h-full" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99457 11.0367L17.9947 10.9717L18.0056 12.9717L6.0054 13.0366L5.99457 11.0367Z" />
                    </svg>
                  </div>
                </td>
                <td class="text-left px-2">{{ violation.time_weight }}</td>
                <td class="text-left px-2">{{ violation.total_severity_weight }}</td>
                <td class="text-left px-2">{{ violation.violation_value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mt-4 p-2 flex justify-center items-center">
        <pagination
          :selected-page="selectedPage"
          :total-pages="totalPages"
          @select-page="onSelectPage"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
// import Pagination from '@/components/Pagination.vue';
import moment from 'moment';
import LineChart from './LineChart.vue';

export default {
  name: 'AcuteOrCriticalSMS',
  components: {
    CustomBadge,
    // Pagination,
    LineChart,
  },
  props: {
    insight: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentSort: 'date',
      currentSortDir: 'asc',
      chartTitle: '',
      chartPercentile: '',
      chartPercentileDescription: '',
      chartWidth: 0,
      chartHeight: 0,
      mounted: false,
      chartData: [],
      top10Pct: 0,
      bottom10Pct: 0,
      selectedPage: 1,
      perPage: 5,
      resizeObserver: null,
    };
  },
  computed: {
    safety() {
      return this.$store.state.carriers.showCarrierSafety;
    },
    // totalPages() {
    //   return Math.ceil(this.selectedViolationsSection.violations.length / this.perPage);
    // },
    // selectedViolationRecords() {
    //  const start = (this.selectedPage - 1) * this.perPage;
    //  const end = start + this.perPage;
    //   return this.selectedViolationsSection.violations.slice(start, end);
    // },
    safetyRatingBgColor() {
      switch (this.safety.safety_rating) {
        case 'Satisfactory':
          return 'bg-green-500';
        case 'Conditional':
          return 'bg-orange-500';
        case 'Unsatisfactory':
          return 'bg-red-500';
        case 'Unrated':
          return 'bg-body-color';
        default:
          return 'bg-body-color';
      }
    },
    // selectedViolationsSection(){
    //   switch(this.chartTitle){
    //     case "Unsafe Driving":
    //       return this.violations.unsafe_driving;
    //     case "Hours-of-Service Compliance":
    //       return this.violations.hos_compliance;
    //     case "Vehicle Maintenance":
    //       return this.violations.vehicle_maintenance;
    //     case "Controlled Substances & Alcohol":
    //       return this.violations.substance_alcohol;
    //     case "Driver Fitness":
    //       return this.violations.driver_fitness;
    //     default:
    //       return this.violations.unsafe_driving;
    //   }
    // },
    safetyChartDataNotEmpty() {
      return (
        !this.emptyElement(
          this.safety?.basic_percentile_rankings?.unsafe_driving
        ) ||
        !this.emptyElement(
          this.safety?.basic_percentile_rankings?.hos_compliance
        ) ||
        !this.emptyElement(
          this.safety?.basic_percentile_rankings?.vehicle_maintenance
        ) ||
        !this.emptyElement(
          this.safety?.basic_percentile_rankings?.substance_alcohol
        ) ||
        !this.emptyElement(
          this.safety?.basic_percentile_rankings?.driver_fitness
        )
      );
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.mounted = true;
    });
  },
  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.safetyChartWrapInsight);
    // window.removeEventListener('resize', this.resizeChart);
  },
  methods: {
    displayDate: function (initialDate) {
      if (initialDate == null) {
        return initialDate;
      } else {
        return moment(initialDate, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    emptyElement: function (value) {
      if (value == null) {
        return true;
      } else if (typeof value === 'object') {
        if (Object.values(value).every((x) => x === null || x === '') == true) {
          return true;
        }
        if (Array.isArray(value)) {
          if (!value.length) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    nullTextify: function (value, nullVal = 'N/A') {
      if (value == null) {
        return nullVal;
      } else {
        return value;
      }
    },
    displayMonthYear: function (date) {
      if (date == null) {
        return date;
      } else {
        return moment(date, 'YYYY-MM-DD').format('MMM YYYY');
      }
    },
    sort: function (s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    resizeChart: function () {
      this.chartWidth = this.$refs.safetyChartWrapInsight?.clientWidth;
      this.chartHeight = this.$refs.safetyChartWrapInsight?.clientHeight;
    },
    onSelectPage: function (newPage) {
      this.selectedPage = newPage;
    },
    onSelectChartTile(newChartTile) {
      this.chartTitle = newChartTile;
      this.selectedPage = 1;
    },
    sortedSmsBasics: function () {
      const copy = [...this.safety.sms_basics];
      copy.sort(function (item1, item2) {
        if (item1.file_date === item2.file_date) {
          return 0;
        }

        if (item1.file_date === null) {
          return 1;
        }
        if (item2.file_date === null) {
          return -1;
        }

        const date1 = moment(item1.file_date, 'YYYY-MM-DD');
        const date2 = moment(item2.file_date, 'YYYY-MM-DD');
        return date1.isAfter(date2) ? 1 : -1;
      });
      return copy;
    },
  },
  watch: {
    // mounted: function (newValue) {
    //   if (newValue == true && this.safetyChartDataNotEmpty) {
    //     this.chartWidth = this.$refs.safetyChartWrapInsight?.clientWidth;
    //     this.chartHeight = this.$refs.safetyChartWrapInsight?.clientHeight;
    //     this.chartTitle = "Unsafe Driving";
    //     this.chartPercentile = this.safety?.sms_basics[0]?.unsafe_driving_measure;
    //     this.chartPercentileDescription = this.safety?.basic_percentile_rankings?.unsafe_driving?.carriers_percentile;
    //   }
    // },
    mounted: {
      handler(newVal) {
        if (newVal == true && this.safetyChartDataNotEmpty) {
          this.chartWidth = this.$refs.safetyChartWrapInsight?.clientWidth;
          this.chartHeight = this.$refs.safetyChartWrapInsight?.clientHeight;
          // this.chartTitle = "Unsafe Driving";
          // this.chartPercentile = this.safety?.sms_basics[0]?.unsafe_driving_measure;
          // this.chartPercentileDescription = this.safety?.basic_percentile_rankings?.unsafe_driving?.carriers_percentile;
          if (Object.keys(this.insight)?.length > 0) {
            if (
              this.insight?.associated_sms_basics?.[0]
                ?.is_unsafe_driving_acute_critical == true
            ) {
              this.chartTitle = 'Unsafe Driving';
              this.chartPercentile =
                this.safety?.sms_basics[0]?.unsafe_driving_measure;
              this.chartPercentileDescription =
                this.safety?.basic_percentile_rankings?.unsafe_driving?.carriers_percentile;
            } else if (
              this.insight?.associated_sms_basics?.[0]
                ?.is_hos_compliance_acute_critical == true
            ) {
              this.chartTitle = 'Hours-of-Service Compliance';
              this.chartPercentile =
                this.safety?.sms_basics[0]?.hos_compliance_measure;
              this.chartPercentileDescription =
                this.safety?.basic_percentile_rankings?.hos_compliance?.carriers_percentile;
            } else if (
              this.insight?.associated_sms_basics?.[0]
                ?.is_vehicle_maintenance_acute_critical == true
            ) {
              this.chartTitle = 'Vehicle Maintenance';
              this.chartPercentile =
                this.safety?.sms_basics[0]?.vehicle_maintenance_measure;
              this.chartPercentileDescription =
                this.safety?.basic_percentile_rankings?.vehicle_maintenance?.carriers_percentile;
            } else if (
              this.insight?.associated_sms_basics?.[0]
                ?.is_substance_alcohol_acute_critical == true
            ) {
              this.chartTitle = 'Controlled Substances & Alcohol';
              this.chartPercentile =
                this.safety?.sms_basics[0]?.substance_alcohol_measure;
              this.chartPercentileDescription =
                this.safety?.basic_percentile_rankings?.substance_alcohol?.carriers_percentile;
            } else if (
              this.insight?.associated_sms_basics?.[0]
                ?.is_driver_fitness_acute_critical == true
            ) {
              this.chartTitle = 'Driver Fitness';
              this.chartPercentile =
                this.safety?.sms_basics[0]?.driver_fitness_measure;
              this.chartPercentileDescription =
                this.safety?.basic_percentile_rankings?.driver_fitness?.carriers_percentile;
            }
          }
        }
        if (newVal == true && this.resizeObserver == null) {
          this.resizeObserver = new ResizeObserver((entries) => {
            // We wrap it in requestAnimationFrame to avoid "ResizeObserver loop limit exceeded" error
            window.requestAnimationFrame(() => {
              if (!Array.isArray(entries) || !entries.length) {
                return;
              }
              this.resizeChart();
            });
          });
          this.resizeObserver.observe(this.$refs.safetyChartWrapInsight);
          // window.addEventListener("resize", this.resizeChart);
        }
      },
      immediate: true,
    },
    // chartTitle: function (newValue, oldValue) {
    chartTitle: function () {
      switch (this.chartTitle) {
        case 'Unsafe Driving':
          this.top10Pct =
            this.safety?.basic_percentile_rankings?.unsafe_driving.top_ten_percent;
          this.bottom10Pct =
            this.safety?.basic_percentile_rankings?.unsafe_driving.bottom_ten_percent;
          this.chartData = this.sortedSmsBasics().map((el) => ({
            name: this.displayMonthYear(el.file_date),
            pl: el.unsafe_driving_measure,
          }));
          this.chartPercentile =
            this.safety?.sms_basics[0]?.unsafe_driving_measure;
          this.chartPercentileDescription =
            this.safety?.basic_percentile_rankings?.unsafe_driving.carriers_percentile;
          break;
        case 'Hours-of-Service Compliance':
          this.top10Pct =
            this.safety?.basic_percentile_rankings?.hos_compliance.top_ten_percent;
          this.bottom10Pct =
            this.safety?.basic_percentile_rankings?.hos_compliance.bottom_ten_percent;
          this.chartData = this.sortedSmsBasics().map((el) => ({
            name: this.displayMonthYear(el.file_date),
            pl: el.hos_compliance_measure,
          }));
          this.chartPercentile =
            this.safety.sms_basics[0].hos_compliance_measure;
          this.chartPercentileDescription =
            this.safety?.basic_percentile_rankings?.hos_compliance.carriers_percentile;
          break;
        case 'Vehicle Maintenance':
          this.top10Pct =
            this.safety?.basic_percentile_rankings?.vehicle_maintenance.top_ten_percent;
          this.bottom10Pct =
            this.safety?.basic_percentile_rankings?.vehicle_maintenance.bottom_ten_percent;
          this.chartData = this.sortedSmsBasics().map((el) => ({
            name: this.displayMonthYear(el.file_date),
            pl: el.vehicle_maintenance_measure,
          }));
          this.chartPercentile =
            this.safety.sms_basics[0].vehicle_maintenance_measure;
          this.chartPercentileDescription =
            this.safety?.basic_percentile_rankings?.vehicle_maintenance.carriers_percentile;
          break;
        case 'Controlled Substances & Alcohol':
          this.top10Pct =
            this.safety?.basic_percentile_rankings?.substance_alcohol.top_ten_percent;
          this.bottom10Pct =
            this.safety?.basic_percentile_rankings?.substance_alcohol.bottom_ten_percent;
          this.chartData = this.sortedSmsBasics().map((el) => ({
            name: this.displayMonthYear(el.file_date),
            pl: el.substance_alcohol_measure,
          }));
          this.chartPercentile =
            this.safety.sms_basics[0].substance_alcohol_measure;
          this.chartPercentileDescription =
            this.safety?.basic_percentile_rankings?.substance_alcohol.carriers_percentile;
          break;
        case 'Driver Fitness':
          this.top10Pct =
            this.safety?.basic_percentile_rankings?.driver_fitness.top_ten_percent;
          this.bottom10Pct =
            this.safety?.basic_percentile_rankings?.driver_fitness.bottom_ten_percent;
          this.chartData = this.sortedSmsBasics().map((el) => ({
            name: this.displayMonthYear(el.file_date),
            pl: el.driver_fitness_measure,
          }));
          this.chartPercentile =
            this.safety.sms_basics[0].driver_fitness_measure;
          this.chartPercentileDescription =
            this.safety?.basic_percentile_rankings?.driver_fitness.carriers_percentile;
          break;
      }
    },
    // sortedRecords: function () {
    //   return Array.prototype.slice.call(this.violations).sort((a, b) => {
    //     let modifier = 1;
    //     if (this.currentSortDir === "desc") modifier = -1;
    //     if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
    //     if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
    //     return 0;
    //   });
    // },
  },
};
</script>

<style scoped>
.chart svg g.layer-marker text {
  font-size: 12px !important;
}
.shadow-orange {
  box-shadow: 0px 5px 10px 0px #ff933040;
}
</style>
